import React from 'react';
import modules_21d2064f from './switch.module.scss.js';

const Switch = ({ id, checked, onChange }) => {
    const onSwitcherChange = (e) => {
        if (!onChange)
            return;
        onChange(e.target.checked);
    };
    const renderSwitch = () => (React.createElement("label", { "data-testid": "mbw-switch", id: id, htmlFor: `checkbox${id}`, className: modules_21d2064f["switch-switch"] },
        React.createElement("input", { "data-testid": "mbw-switch-slider", id: `checkbox${id}`, type: "checkbox", checked: checked, onChange: onSwitcherChange }),
        React.createElement("span", { className: modules_21d2064f["switch-slider"] })));
    return renderSwitch();
};
Switch.displayName = "Switch";

export { Switch as default };
//# sourceMappingURL=switch.js.map
